module.exports = __webpack_public_path__ + "static/train-a218d5861464308c109b4eda06b6efef.jpg";